/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2017, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

/**
 * Parse an oauth error and provide a message to be displayed to the user.
 * @param err - Error object
 *        t - translation function
 */
export async function getOauthErrorMessage(err, t) {
  const messages = {
    invalid_client: t('invalid_client'),
    unauthorized_client: t('invalid_client'),
    access_denied: t('access_denied'),
    invalid_scope: t('invalid_scope'),
    invalid_grant: t('invalid_grant'),
    generic_invoke_error: t('generic_invoke_error'),
    '404_not_found': t('404_not_found'),
    fetch_error: t('explorer_cors')
  };

  let authError = err;

  let msgKey;
  if (authError.data && authError.data.error) {
    msgKey = authError.data.error;
  } else if (authError.text) {
    msgKey = authError.text;
  } else if (authError.status && authError.status === 404) {
    msgKey = '404_not_found';
  } else if (authError.message && authError.message.includes('Failed to fetch')) {
    msgKey = 'fetch_error';
  } else {
    msgKey = 'generic_invoke_error';
  }

  authError.highlightedText = { __html: messages[msgKey] };

  return authError;
}

export async function getMixedContentMessage(t) {
  let authError = {};

  authError.highlightedText = { __html: t('mixedcontent_error', null) };
  return authError;
}
